import { apiClient } from './apiClient';

export interface ChatbotFaqItem {
  question: string;
  answer: string;
}

export type ChatbotWidgetTheme = 'light' | 'dark';
export type ChatbotLauncherPosition = 'bottom_right' | 'bottom_left';
export type ChatbotAutoOpenMode = 'panel' | 'teaser';

export interface ChatbotManageConfig {
  enabled: boolean;
  business_name: string;
  business_summary: string;
  faqs: ChatbotFaqItem[] | Record<string, unknown>[];
  allowed_domains: string[];
  welcome_message: string;
  notification_emails: string[];
  primary_color: string;
  widget_theme: ChatbotWidgetTheme;
  launcher_position: ChatbotLauncherPosition;
  auto_open_enabled: boolean;
  auto_open_delay_seconds: number;
  auto_open_mode: ChatbotAutoOpenMode;
  proactive_message: string;
  updated_at?: string;
  tenant_id?: string;
  embed_snippet?: string;
}

export interface ChatSessionRow {
  id: string;
  public_token: string;
  page_url: string;
  ip_address: string | null;
  created_at: string;
  updated_at: string;
  message_count: number;
}

export interface ChatMessageRow {
  id: string;
  role: string;
  content: string;
  created_at: string;
}

export interface ChatbotLeadRow {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  service_interest: string;
  crm_lead: string | null;
  created_at: string;
}

export const chatbotService = {
  async getConfig(): Promise<ChatbotManageConfig> {
    return apiClient.get('/chatbot/manage/config/');
  },

  async patchConfig(data: Partial<ChatbotManageConfig>): Promise<ChatbotManageConfig> {
    return apiClient.patch('/chatbot/manage/config/', data);
  },

  async listSessions(page = 1): Promise<{ count: number; results: ChatSessionRow[] }> {
    return apiClient.get('/chatbot/manage/sessions/', { page });
  },

  async sessionMessages(sessionId: string): Promise<ChatMessageRow[]> {
    return apiClient.get(`/chatbot/manage/sessions/${sessionId}/messages/`);
  },

  async listLeads(page = 1): Promise<{ count: number; results: ChatbotLeadRow[] }> {
    return apiClient.get('/chatbot/manage/leads/', { page });
  },
};
